import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

export const typographyStyles = { p: 3 };
export const mainBoxStyles = { width: '100%' };
export const childBoxStyles = { borderColor: 'divider' };

type RuleNames =
  | 'mainTabsBlock'
  | 'tabs'
  | 'activeTabs';

const PREFIX = 'TabsPanel';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      mainTabsBlock: {
        marginTop: '5px',
        '& .MuiTabs-indicator': {
          display: 'none',
        },
      },
      tabs: {
        fontFamily: theme.helveticaNeueMedium,
        fontWeight: 500,
        fontSize: '20px',
        color: theme.lightGreen,
        marginRight: '23px',
        paddingBottom: '5px',
        borderBottom: '2px solid #fff',
        cursor: 'pointer',
        transition: 'all 300ms ease',
        '&:hover': {
          color: theme.green,
          borderBottom: '2px solid #3B5D3E',
        },
      },
      activeTabs: {
        color: theme.green,
        borderBottom: '2px solid #3B5D3E',
      },
    }
  ),
  { name: PREFIX },
);
